// Consent of run 1, kept on the phone for a reopened multi-run link (hezo-ops
// SCAN_MODEL_FLOW § Phase 3). A customer who drops out after run 1 and opens
// the link again continues at run 2 without consent and checklist, because
// both were done on this phone. Another phone has nothing stored and walks
// through consent as before. Only the paper format is stored, no personal
// data; keyed by the invite link, which is already in this phone's history.

import type { PaperFormat } from "../components/CaptureFlow";

const KEY_PREFIX = "hezo-scan-run-consent:";
/** A link lives 7 days; a consent older than that belongs to another visit. */
const MAX_AGE_MS = 8 * 24 * 60 * 60 * 1000;
const FORMATS: readonly PaperFormat[] = ["A4", "Letter"];

export function storeRunConsent(token: string, paperFormat: PaperFormat): void {
  try {
    localStorage.setItem(KEY_PREFIX + token, JSON.stringify({ paperFormat, at: Date.now() }));
  } catch {
    // Private mode or storage blocked: the reopened link asks again.
  }
}

export function loadRunConsent(token: string): { paperFormat: PaperFormat } | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + token);
    if (!raw) return null;
    const v = JSON.parse(raw) as { paperFormat?: unknown; at?: unknown };
    if (!FORMATS.includes(v.paperFormat as PaperFormat)) return null;
    if (typeof v.at !== "number" || Date.now() - v.at > MAX_AGE_MS) return null;
    return { paperFormat: v.paperFormat as PaperFormat };
  } catch {
    return null;
  }
}
